export const SMS = 1;
export const EMAIL = 2;



// WEBPACK FOOTER //
// ./js/constants/FastJoinType.js